var company = {};
module['exports'] = company;
company.suffix = require("./suffix");
company.name = require("./name");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sv/company/index.js
 ** module id = 1075
 ** module chunks = 0
 **/